import {
  FETCH_MONTHDATA_SUCCESS,
} from "../Constants";

const initialAuthState = {};

export default (state = initialAuthState, action) => {
  switch (action.type) {
    case FETCH_MONTHDATA_SUCCESS:
      return {
        payload: action.data
      };
    default:
      return state;
  }
};
